import {Component, EventEmitter, Inject, Input, isDevMode, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormArray, FormGroup, Validators} from '@angular/forms';
import {GroupConfig} from '../../../shared/models/config';
import {GetConfigOrderService} from '../../services/get-config-order.service';
import {debounceTime, distinctUntilChanged, filter, skipWhile} from 'rxjs/operators';
import * as _ from 'lodash';
import * as moment from 'moment';
import {ActionsSubject, select, Store} from '@ngrx/store';
import * as fromOrder from '../../reducers';
import * as fromRoot from '../../../shared/reducers';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {ServerForm, ServerFormUrl} from '../../../shared/models/servers';
import {PatchOrdersAction} from '../../actions/order-patch';
import {OrderForm} from '../../models/order-form';
import {Order} from '../../models/order';
import {FindInvalidControlsService} from '../../../shared/services/find-invalid-controls.service';
import {UpdateDynamicFormService} from '../../../shared/services/update-dynamic-form.service';
import {WifiFormLogicService} from '../../../shared/services/wifi-form-logic.service';
import {ModalComponent} from '@storever/modal-confirmation';
import {RemoveOrderPlayerAction} from '../../actions/order-remove-player';
import {LoadProductsCompleteListAction} from '../../../shared/actions/product-complete-list';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Product} from '../../../shared/models/product';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {LoadServerURLAction} from '../../../shared/actions/servers-url';
import {LoadProductsByServiceAction} from '../../../shared/actions/product';
import {CheckDispatchDateAddAction, CheckDispatchDateSuccessAction} from '../../actions/check-dispatch-date';
import {LoadSiteFullSummariesAction} from '../../../shipping/actions/site-summaries';
import {AddressSummaries} from '../../../shared/models/address';
import {LoadConceptsAction} from '../../../shared/actions/concept';
import {ConceptOrder} from '../../../shared/models/concept';
import {LoadCMSAction} from '../../../shared/actions/cms';
import {LoadMySitesAction} from '../../../shared/actions/my-sites';
import {LoadProductionLineWithParamsAction} from '../../../shared/actions/production-line';
import {ProductionLine} from '../../../shared/models/production-line';
import {Role} from '../../../shared';
import * as fromShared from '../../../shared/reducers';

@Component({
  selector: 'storever-order-add',
  templateUrl: './order-add.component.html',
  styleUrls: ['./order-add.component.scss']
})
export class OrderAddComponent implements OnInit, OnChanges, OnDestroy {

  @Input() form: FormGroup;
  @Input() isEdit: boolean;
  @Input() isExchange: boolean;
  @Input() isAdd: boolean;
  @Input() orderForm: OrderForm;
  @Input() order: Order;
  @Input() addressSummaries: AddressSummaries[];
  @Input() isLoading: boolean;
  @Input() isInternalUser: boolean;
  @Output() resetDhlMsg: EventEmitter<void> = new EventEmitter<void>();
  isVideo = false;
  formConfigSite: GroupConfig;
  formConfigAddress: GroupConfig;
  formConfigContact: GroupConfig;
  formConfigSubscription: GroupConfig;
  getConfigOrderSubNetIp: GroupConfig;
  getConfigOrderSubNetProxy: GroupConfig;
  getConfigOrderSubNetWifi: GroupConfig;
  getConfigOrderMisc: GroupConfig;
  getConfigOrderMiscDatePicker: GroupConfig;
  getConfigOrderMiscCreated: GroupConfig;
  formConfigSiteOthers: GroupConfig;
  formConfigSubscriptionOthers: GroupConfig;
  getConfigServer: GroupConfig;
  productionLine$: Observable<ProductionLine[]>;
  getConfigDeliveryAddress: GroupConfig;
  getConfigOrderMiscPlayer: GroupConfig;
  getConfigProductionLine: GroupConfig;
  getConfigConcepts: GroupConfig;
  servers$: Observable<ServerForm[]>;
  cms$: Observable<ServerForm[]>;
  servers: ServerForm[];
  isLoadingWifi = false;
  isConcepts = false;
  isPlayer = true;
  private sub$: Subscription;
  private subscriptions = [];
  bsModalRef: BsModalRef;
  product$: Observable<Product[]>;
  serverURLS$: Observable<ServerFormUrl[]>;
  nextSuggestedDate: string;
  currentProductName: string;
  concepts$: Observable<ConceptOrder[]>;
  productSelected: number;
  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private getConfigOrder: GetConfigOrderService,
              private store: Store<fromOrder.AppState>,
              private findInvalidControlsService: FindInvalidControlsService,
              private updateDynamicFormService: UpdateDynamicFormService,
              private modalService: BsModalService,
              private storeRoot: Store<fromRoot.AppState>,
              private dispatcher: ActionsSubject,
              private wifiFormLogicService: WifiFormLogicService) {
  }

  ngOnInit(): void {

    this.loadServerUrlList();
    this.product$ = this.storeRoot.pipe(select(fromRoot.selectors.getProducts));
    this.productionLine$ = this.storeRoot.pipe(select(fromRoot.selectors.getProductionLine));
    this.serverURLS$ = this.storeRoot.pipe(select(fromRoot.selectors.getServerUrl));
    this.formConfigSite = this.getConfigOrder.getConfigOrderSite();
    if (this.isExchange) {
      this.formConfigSubscription = this.getConfigOrder.getConfigOrderSubscription();
    } else {
      this.formConfigSubscription = this.getConfigOrder.getConfigOrderSubscriptionBis();
    }

    this.formConfigSubscriptionOthers = this.getConfigOrder.formConfigSubscriptionOthers();
    this.getConfigServer = this.getConfigOrder.getConfigServer();
    this.formConfigAddress = this.getConfigOrder.getConfigOrderAddress();
    this.formConfigContact = this.getConfigOrder.getConfigOrderContact();
    this.getConfigOrderSubNetIp = this.getConfigOrder.getConfigOrderSubNetworkIpAddress();
    this.getConfigOrderSubNetProxy = this.getConfigOrder.getConfigOrderSubNetworkProxy();
    this.getConfigOrderMisc = this.getConfigOrder.getConfigOrderMisc();
    this.getConfigOrderMiscCreated = this.getConfigOrder.getConfigOrderMiscCreated();
    this.getConfigOrderMiscDatePicker = this.getConfigOrder.getConfigOrderMiscDatePicker();
    this.getConfigDeliveryAddress = this.getConfigOrder.getConfigDeliveryAddress();
    this.getConfigOrderSubNetWifi = this.getConfigOrder.getConfigOrderSubNetworkWifi();
    this.getConfigOrderMiscPlayer = this.getConfigOrder.getConfigOrderMiscPlayer();
    this.getConfigProductionLine = this.getConfigOrder.getConfigOrderProductionLine();
    this.getConfigConcepts = this.getConfigOrder.getConfigConcepts();
    if (this.isAdd) {
      this.form.get(['site', 'ianaCode']).disable();
      this.form.get(['site', 'timezoneName']).disable();
    }
    if (!this.isExchange) {
      // network
      this.wifiFormLogicService.setMandatoryProxy(this.form, ['subscription', 'network', 'proxy']);
      this.setMandatory(this.form);
      // end network
    }
    if (this.isExchange) {
      this.formConfigSubscription.config[0].data = 'productsCompleteList';
    }
    if (!this.isExchange && !this.isEdit) {
      // this.form.get(['productionLine', 'productionLine', 'code']).patchValue('BXL')
      this.sub$ = this.productionLine$.pipe(
        skipWhile(o => o === null)
      ).subscribe((productionLine: ProductionLine[]) => {
        if (productionLine.length > 0) {
          this.form.get(['productionLine', 'productionLine', 'code']).patchValue(productionLine[0].code);
        }

      });
      this.subscriptions.push(this.sub$);
    }
    this.setDispatch(this.getConfigOrderMiscDatePicker);
    this.cms$ = this.store.pipe(select(fromRoot.selectors.getCMS));
    this.servers$ = this.store.pipe(select(fromRoot.selectors.getServer));
    this.subscribeServer();
    this.wifiFormLogicService.wifiToggleElemInit(this.form.get(['subscription', 'network']), this.isLoadingWifi);

    this.sub$ = this.form.get(['misc', 'expeditionForm', 'expeditionDate']).valueChanges.subscribe(value => {
      if (!this.isExchange && !this.isEdit) {
        this.storeRoot.dispatch(new CheckDispatchDateAddAction(value));
      }

    })
    this.subscriptions.push(this.sub$);
    this.sub$ = this.form.get(['site', 'uuid']).valueChanges.pipe(
      distinctUntilChanged((x, y) => _.isEqual(x, y))).subscribe(val => {
      if (val) {
       // this.form.get(['subscription', 'general' , 'name']).clearValidators();
       // this.form.get(['subscription', 'general' , 'name']).updateValueAndValidity();
        this.store.dispatch(new LoadSiteFullSummariesAction({clientUuid: this.form.get(['client', 'uuid']).value, siteUuid: val}));
      }
    });
    this.subscriptions.push(this.sub$);

    this.sub$ = this.form.get(['site', 'name']).valueChanges.pipe(
      distinctUntilChanged((x, y) => _.isEqual(x, y))).subscribe(val => {
      if (val) {
        if (!this.isExchange && !this.isEdit ) {
          this.formConfigSubscriptionOthers.config[0].options.inputExtraLabels = val + ' ' + ( this.currentProductName ? this.currentProductName : ' ' );
          this.form.get(['subscription', 'base', 'prefix']).patchValue(this.formConfigSubscriptionOthers.config[0].options.inputExtraLabels);
        }
      }
    });
    this.subscriptions.push(this.sub$);


    // const site = _.find(this.addressSummaries, gr =>
    //   gr.addressType.replace(/ /g, '') === value.replace(/ /g, ''));
    // if (this.form) {
    //   this.form.get('address').patchValue(site.address);
    //   this.form.get(['address', 'countryForm', 'name']).patchValue(site.address.country);
    //   if (site.contact) {
    //     this.form.get('contact').patchValue(site.contact);
    //   }
   // }
   //  this.sub$ = this.dispatcher.pipe(
   //    debounceTime(700),
   //    filter(action => action.type === '[orders] Add Success')
   //  ).subscribe(() => {
   //    this.store.dispatch(new LoadMySitesAction(this.form.get(['client' , 'uuid']).value));
   //    this.formConfigSubscriptionOthers.config[0].options.inputExtraLabels = ' ' ;
   //    this.form.get(['subscription', 'base', 'prefix']).patchValue(this.formConfigSubscriptionOthers.config[0].options.inputExtraLabels);
   //  });

    this.sub$ = this.form.get(['subscription', 'base', 'productForm', 'service', 'id']).valueChanges.subscribe(value => {
      if (!this.isExchange) {
        this.storeRoot.dispatch(new LoadProductsByServiceAction(value));
      }

    })
    this.subscriptions.push(this.sub$);
  }
  loadConcept(): void {
    this.concepts$ = this.store.pipe(select(fromOrder.selectors.getConceptsOrder));
    this.concepts$.subscribe(data => {
      const conceptsIds  = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          conceptsIds.push(data[i].conceptID)
        }
        this.form.get(['concepts', 'concepts', 'id']).patchValue(conceptsIds)
      }
    });
  }

  subscribeServer(): void {
    this.serverURLS$.subscribe(data => {
      if (data && data.length > 0 && this.isPlayer && (this.isAdd || this.isExchange)) {

        for (let j = 0; j < data.length; j++) {
          if (this.form.get(['subscription', 'base', 'serverForm' , 'cms', 'id']).value === data[j].id) {
            this.form.get(['subscription', 'base', 'serverForm' , 'url', 'id']).patchValue(data[j].id);
          }
        }

      }
    })
    this.cms$.subscribe(data => {
      if (data && data.length > 0 && this.isPlayer) {
        this.form.get(['subscription', 'base', 'serverForm'  , 'url', 'id']).setValidators([Validators.required]);
        this.form.get(['subscription', 'base', 'serverForm' , 'url', 'id']).updateValueAndValidity();
        this.form.get(['subscription', 'base', 'serverForm' , 'cms', 'id']).updateValueAndValidity();
        this.form.get(['subscription', 'base', 'serverForm' , 'cms', 'id']).setValidators([Validators.required]);
        if (this.isAdd || this.isExchange) {
          for (let q = 0; q < data.length; q++) {
            if (data[q].name.toLowerCase().search('dxp') !== -1 ) {
              this.form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).patchValue(data[q].id)
            }
            if (!this.form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).value &&
              this.isVideo && data[q].name.toLowerCase().search('ds') !== -1) {
              this.form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).patchValue(data[q].id)
            }
            if (!this.form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).value &&
              !this.isVideo && data[q].name.toLowerCase().search('mus') !== -1) {
              this.form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).patchValue(data[q].id)
            }
          }
          if (!this.form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).value) {
             this.form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).patchValue(data[0].id)
         }
        }

     //   this.form.get(['subscription', 'base', 'serverForm' , 'server', 'id']).setValidators([Validators.required]);
      //  this.form.get(['subscription', 'base', 'serverForm' ,  'server' , 'id']).updateValueAndValidity();
        this.servers = data;
      } else {
        this.form.get(['subscription', 'base', 'serverForm' , 'url', 'id']).clearValidators();
      //  this.form.get(['subscription', 'base', 'serverForm' , 'server', 'id']).clearValidators();
        this.form.get(['subscription', 'base', 'serverForm' , 'cms', 'id']).clearValidators();
        this.form.get(['subscription', 'base', 'serverForm' , 'cms',  'id']).updateValueAndValidity();
        this.form.get(['subscription', 'base', 'serverForm' , 'url',  'id']).updateValueAndValidity();
      //  this.form.get(['subscription', 'base', 'serverForm' , 'server', 'id']).updateValueAndValidity();
      }
    })
  }
  loadServerUrlList(): void {
    this.sub$ = this.form.get(['subscription', 'base', 'serverForm' , 'cms',  'id']).valueChanges.pipe(
      debounceTime(700)
    ).subscribe(val => {
      if (val) {
        this.store.dispatch(new LoadServerURLAction({
          'server' : val,
          'serviceType': !this.isVideo  ? 1 : 2
        }));
      }
    })
    this.subscriptions.push(this.sub$);
  }

  setLinkPlayer(clientUuid: string, deviceID: string): void {
    const url = 'https://portal.mcubedigital.com/' + clientUuid + '/players/' + deviceID;
    // const url = 'https://portal.storever.com/' + '788af3c3-6044-4344-b5d3-b75f823dc5fe' + '/players/' + '9E7DF0ED-2A5C-4A19-BEC7-ECF00E4DAF92';
    this.getConfigOrderMiscPlayer.config[0].linkHref.url = url
  }

  isEnabled(path: string[]): boolean {
    return this.form.get(path).enabled
  }

  productFormChangeResetWifiEnableScreenRot(changes: SimpleChanges): void {
    // tslint:disable-next-line:no-any

    this.sub$ = changes.form.currentValue.get(['subscription', 'base', 'productForm', 'product', 'id']).valueChanges.subscribe(val => {
      this.product$.subscribe(product => {if (product) {
        // tslint:disable-next-line:typedef
        const currentProduct = _.filter(product, function(o) { return o.id === val; })
        if (!this.isExchange && !this.isEdit && currentProduct.length > 0 ) {
          this.currentProductName = currentProduct[0].name;
          this.storeRoot.dispatch(new LoadProductionLineWithParamsAction(
            {productID : currentProduct[0].id , clientUuid : this.form.get(['client', 'uuid']).value
          }));
          this.formConfigSubscriptionOthers.config[0].options.inputExtraLabels = this.form.get(['site', 'name']).value + ' ' + currentProduct[0].name;
          this.form.get(['subscription', 'base', 'prefix']).patchValue(this.formConfigSubscriptionOthers.config[0].options.inputExtraLabels);
        }

        if (currentProduct.length > 0 ) {

          if (!currentProduct[0].managed) {
            this.form.get(['subscription', 'network', 'ipAddress', 'dns1']).setValidators(null);
            this.form.get(['subscription', 'network', 'ipAddress', 'dns1']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).setValidators(null);
            this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).setValidators(null);
            this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'mask']).setValidators(null);
            this.form.get(['subscription', 'network', 'ipAddress', 'mask']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'ip']).setValidators(null);
            this.form.get(['subscription', 'network', 'ipAddress', 'ip']).updateValueAndValidity();
            this.form.get(['subscription', 'base', 'serverForm', 'url', 'id']).clearValidators();
           // this.form.get(['subscription', 'base', 'serverForm', 'server', 'id']).clearValidators();
            this.form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).clearValidators();
            this.form.get(['subscription', 'base', 'serverForm', 'cms', 'id']).updateValueAndValidity();
            this.form.get(['subscription', 'base', 'serverForm', 'url', 'id']).updateValueAndValidity();
           // this.form.get(['subscription', 'base', 'serverForm', 'server', 'id']).updateValueAndValidity();
            this.isPlayer = false;
          } else {
            this.form.get(['subscription', 'network', 'ipAddress', 'dns1']).setValidators([Validators.required]);
            this.form.get(['subscription', 'network', 'ipAddress', 'dns1']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).setValidators([Validators.required]);
            this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).setValidators([Validators.required]);
            this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'mask']).setValidators([Validators.required]);
            this.form.get(['subscription', 'network', 'ipAddress', 'mask']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'ip']).setValidators([Validators.required]);
            this.form.get(['subscription', 'network', 'ipAddress', 'ip']).updateValueAndValidity();
            this.subscribeServer();
            this.isPlayer = true;
          }
        }
        if (currentProduct.length > 0 && currentProduct[0].wifiAvailable) {
          this.isVideo = true;
          this.wifiFormLogicService.videoStatus(this.isVideo);
        } else {
          this.isVideo = false;
          this.form.get(['subscription', 'network', 'wifi']).reset();
          this.wifiFormLogicService.videoStatus(this.isVideo);
        }
       // console.log('----------------------------' , currentProduct)
       // console.log('----------------------------' , this.productSelected)
        if (currentProduct.length > 0 && this.productSelected !== currentProduct[0].id) {
          this.store.dispatch(new LoadCMSAction({
            'productID': currentProduct[0].id,
            'serviceType': !this.isVideo ? 1 : 2
          }));
        }
      //  console.log('-------------------this.productSelected', this.productSelected)

        if (val) {
          this.productSelected = val;
        }
        // tslint:disable-next-line:no-unused-expression
        this.isEnabled(['subscription', 'base', 'productForm']) ? this.enableScreenRotation(this.isVideo) : null;
      }
      })
    });
    this.subscriptions.push(this.sub$);
    this.sub$ = changes.form.currentValue.get(['subscription', 'base', 'productForm', 'service', 'id']).valueChanges.pipe(
      debounceTime(10),
      distinctUntilChanged()
    ).subscribe(val => {
      // if (this.productSelected) {
      //   this.store.dispatch(new LoadCMSAction({
      //     'productID': this.productSelected,
      //     'serviceType': !this.isVideo ? 1 : 2
      //   }));
      // }
      if ( val && val !== 1 && val !== 2) {
        this.form.get(['subscription', 'network', 'ipAddress', 'dns1']).setValidators(null);
        this.form.get(['subscription', 'network', 'ipAddress' , 'dns1']).updateValueAndValidity();
        this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).setValidators(null);
        this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).updateValueAndValidity();
        this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).setValidators(null);
        this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).updateValueAndValidity();
        this.form.get(['subscription', 'network', 'ipAddress', 'mask']).setValidators(null);
        this.form.get(['subscription', 'network', 'ipAddress', 'mask']).updateValueAndValidity();
        this.form.get(['subscription', 'network', 'ipAddress', 'ip']).setValidators(null);
        this.form.get(['subscription', 'network', 'ipAddress', 'ip']).updateValueAndValidity();
        this.formConfigSubscription = this.getConfigOrder.getConfigOrderSubscription();
        this.isPlayer = false;
      } else {
        this.form.get(['subscription', 'network', 'ipAddress', 'dns1']).setValidators([Validators.required]);
        this.form.get(['subscription', 'network', 'ipAddress' , 'dns1']).updateValueAndValidity();
        this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).setValidators([Validators.required]);
        this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).updateValueAndValidity();
        this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).setValidators([Validators.required]);
        this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).updateValueAndValidity();
        this.form.get(['subscription', 'network', 'ipAddress', 'mask']).setValidators([Validators.required]);
        this.form.get(['subscription', 'network', 'ipAddress', 'mask']).updateValueAndValidity();
        this.form.get(['subscription', 'network', 'ipAddress', 'ip']).setValidators([Validators.required]);
        this.form.get(['subscription', 'network', 'ipAddress', 'ip']).updateValueAndValidity();
        this.formConfigSubscription = this.getConfigOrder.getConfigOrderSubscriptionBis();
        this.isPlayer = true;
        this.subscribeServer();
      }
    });
    this.subscriptions.push(this.sub$);
    this.sub$ = changes.form.currentValue.get(['subscription', 'base', 'productForm', 'product', 'id']).valueChanges.pipe(
      debounceTime(10),
      distinctUntilChanged()
    ).subscribe(val => {
      this.form.get(['subscription', 'general' , 'name']).clearValidators();
      this.form.get(['subscription', 'general' , 'name']).updateValueAndValidity();
      this.product$.subscribe(product => { if (product) {
        // tslint:disable-next-line:typedef
        const currentProduct = _.filter(product, function(o) { return o.id === val; })
        if (currentProduct.length > 0) {

          if (currentProduct[0].id === 24  || currentProduct[0].id === 27 || currentProduct[0].id === 28) {
            this.isConcepts = true;
          } else {
            this.isConcepts = false;
          }
          if (!currentProduct[0].managed) {
            this.form.get(['subscription', 'network', 'ipAddress', 'dns1']).setValidators(null);
            this.form.get(['subscription', 'network', 'ipAddress', 'dns1']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).setValidators(null);
            this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).setValidators(null);
            this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'mask']).setValidators(null);
            this.form.get(['subscription', 'network', 'ipAddress', 'mask']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'ip']).setValidators(null);
            this.form.get(['subscription', 'network', 'ipAddress', 'ip']).updateValueAndValidity();
            this.isPlayer = false;
          } else {
            this.form.get(['subscription', 'network', 'ipAddress', 'dns1']).setValidators([Validators.required]);
            this.form.get(['subscription', 'network', 'ipAddress', 'dns1']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).setValidators([Validators.required]);
            this.form.get(['subscription', 'network', 'ipAddress', 'dns2']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).setValidators([Validators.required]);
            this.form.get(['subscription', 'network', 'ipAddress', 'gateway']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'mask']).setValidators([Validators.required]);
            this.form.get(['subscription', 'network', 'ipAddress', 'mask']).updateValueAndValidity();
            this.form.get(['subscription', 'network', 'ipAddress', 'ip']).setValidators([Validators.required]);
            this.form.get(['subscription', 'network', 'ipAddress', 'ip']).updateValueAndValidity();
            this.isPlayer = true;
            this.subscribeServer();
          }
        }
        if (currentProduct.length > 0 && currentProduct[0].wifiAvailable) {
        if (!this.form.get(['subscription', 'network', 'wifi', 'ssid']).value) {
          this.form.get(['subscription', 'network', 'wifi', 'enable']).patchValue(false);
        }
      } else {
        this.form.get(['subscription', 'network', 'wifi', 'enable']).patchValue(true);
        this.wifiFormLogicService.clearWifiValidator(this.form.get(['subscription', 'network']));
      }
        if (currentProduct.length > 0 && currentProduct[0].id) {
          this.store.dispatch(new LoadCMSAction({
            'productID': currentProduct[0].id,
            'serviceType': !this.isVideo ? 1 : 2
          }));
        }
      }
                                           if (this.orderForm && this.orderForm.subscription.network.wifi) {
        this.form.get(['subscription', 'network', 'wifi']).patchValue(this.orderForm.subscription.network.wifi);
        this.form.get(['subscription', 'network', 'wifi']).markAsPristine();
      }
      })
    });
    this.subscriptions.push(this.sub$);

  }

  enableScreenRotation(isVideo: boolean): void {
    const form = this.form.get(['subscription', 'base', 'productForm', 'screenRotation']);
    if (isVideo) {
      form.enable();
      this.updateDynamicFormService.updateElement('screenRotation', true, 'toggle');
      this.form.get(['subscription', 'base', 'productForm', 'screenRotation', 'id']).setValidators([Validators.required]);
      this.form.get(['subscription', 'base', 'productForm', 'screenRotation', 'id']).updateValueAndValidity();
      if (!this.form.get(['subscription', 'base', 'productForm', 'screenRotation', 'id']).value) {
        this.form.get(['subscription', 'base', 'productForm', 'screenRotation', 'id']).patchValue(0, { onlySelf: true, emitEvent: false });
      }
    } else {
      this.updateDynamicFormService.updateElement('screenRotation', false, 'toggle');
      form.disable();
      this.form.get(['subscription', 'base', 'productForm', 'screenRotation', 'id']).setValidators(null);
      this.form.get(['subscription', 'base', 'productForm', 'screenRotation', 'id']).updateValueAndValidity();
      this.form.get(['subscription', 'base', 'productForm', 'screenRotation', 'id']).patchValue(null, { onlySelf: true, emitEvent: false });
    }
  }

  ngOnChanges(changes: SimpleChanges): void { // TODO: move to parent order-detail
    if (changes.form && changes.form.currentValue) {
      // network
      this.wifiFormLogicService.isDhcpValueChange(changes.form.currentValue, ['subscription', 'network', 'ipAddress']);
      this.wifiFormLogicService.isWifiEnabledChange(changes.form.currentValue, ['subscription', 'network', 'wifi']);
      // end network
      this.addressShippingValueChangeSetState();
      this.productFormChangeResetWifiEnableScreenRot(changes);
    }
    if (changes.order && changes.order.currentValue) {
      if (changes.order.currentValue.status > 0) {
        this.setLinkPlayer(changes.order.currentValue.client.uuid, changes.order.currentValue.player.deviceID);
      }
      const orderProduct =  this.form.get(['subscription', 'base', 'productForm' , 'product' , 'id']).value;
      if (orderProduct === 24  || orderProduct === 27 || orderProduct === 28) {
        this.storeRoot.dispatch(new LoadConceptsAction(changes.order.currentValue.client.uuid));
        this.isConcepts = true;
      }
    }
    if (changes.addressSummaries && changes.addressSummaries.currentValue) {
      const site = changes.addressSummaries.currentValue;
      if (site && site.contacts.length > 0 ) {
        this.form.get('contact').patchValue(site.contacts[0].contact)
      }
      if (site && site.addresses.length > 0 ) {
        if (!this.isExchange && !this.isEdit ) {

          if (!this.form.get(['subscription', 'base', 'productForm' , 'product' , 'id']).value) {
            this.formConfigSubscriptionOthers.config[0].options.inputExtraLabels = this.form.get(['site', 'name']).value ;
            this.form.get(['subscription', 'base', 'prefix']).patchValue(this.form.get(['site', 'name']).value) ;
          }
          this.product$.subscribe(data => {
            for (let i = 0; i < data.length; i++) {
              if (data[i].id === this.form.get(['subscription', 'base', 'productForm' , 'product' , 'id']).value) {
                  this.formConfigSubscriptionOthers.config[0].options.inputExtraLabels = this.form.get(['site', 'name']).value + ' ' + data[i].name;
                  this.form.get(['subscription', 'base', 'prefix']).patchValue(
                  this.form.get(['site', 'name']).value + ' ' + data[i].name
                ) ;
              }
            }
          })
        }

        if (site.addresses.length > 1) {
          if (site.addresses[1].addressType === 'Shipping') {
            this.getArrayAddress(1).get('checkBox').patchValue(false);
            this.getArrayAddress(1).get(['countryForm', 'name']).patchValue(site.addresses[1].country);
            this.form.get('addresses').patchValue(site.addresses)
            this.getArrayAddress(0).get(['countryForm', 'name']).patchValue(site.addresses[0].country);
          } else {
            this.getArrayAddress(1).get('checkBox').patchValue(false);
            this.getArrayAddress(1).get(['countryForm', 'name']).patchValue(site.addresses[0].country);
            this.form.get('addresses').patchValue(site.addresses)
            this.getArrayAddress(0).get(['countryForm', 'name']).patchValue(site.addresses[4].country);
          }

        } else {
          this.form.get('addresses').patchValue(site.addresses)
          this.getArrayAddress(0).get(['countryForm', 'name']).patchValue(site.addresses[0].country);
        }

      }
    }

  }

  setDispatch(value: GroupConfig): void {
    if (!this.isExchange) {
      this.form.get(['misc', 'expeditionForm', 'expeditionDate']).patchValue(this.performDate(value));
      this.storeRoot.dispatch(new CheckDispatchDateAddAction(this.performDate(value)));
      this.sub$ = this.dispatcher.pipe(
        filter(action => action.type === '[Get Dispatch Date] Get Success'),
      ).subscribe((data: CheckDispatchDateSuccessAction) => {
        this.nextSuggestedDate = data.payload.data.nextSuggestedDate
        this.form.get(['misc', 'expeditionForm', 'orderCountThisDay']).patchValue(
          data.payload.data.numberOfPlayers);
      });
      this.subscriptions.push(this.sub$);
    }
  }

  // tslint:disable-next-line:no-any
  performDate(value: any): any {
     const date = moment().add(value.config[0].options.datePicker.numberDelayDays, 'days');
     if (date.day() === 6) {
       date.add(2, 'days');
     } else if (date.day() === 7) {
       date.add(1, 'days');
     }
     return date.format('YYYY-MM-DD')
   }
  setMandatory(form: FormGroup): void { // TODO: move to parent order-detail
    this.wifiFormLogicService.validatorWifi(this.form.get(['subscription', 'network']));
    this.wifiFormLogicService.setMandatoryProxy(form, ['subscription', 'network', 'proxy']);
    this.wifiFormLogicService.validatorWifiSecurity(this.form.get(['subscription', 'network']) );
    this.wifiFormLogicService.validatorWifiEap(this.form.get(['subscription', 'network']) );
  }
  // end network



  addressShippingValueChangeSetState(): void {
    this.sub$ = this.getArrayAddress(1).get('checkBox').valueChanges.subscribe(val => {
      const arr = this.getArrayAddress(1);
      if (arr.enabled) {
        if (!val) {
         arr.enable({ emitEvent: false });
         // arr.get('id').patchValue(null);
         // arr.get('uuid').patchValue(null);
        } else {
          this.resetOrDisableFormDataFromList('disable', arr, ['line1', 'line2', 'line3', 'zip', 'city', 'state', 'countryForm']);
          this.resetOrDisableFormDataFromList('reset', arr, ['line1', 'line2', 'line3', 'zip', 'city', 'state', 'countryForm']);
        }
      }
    });
    this.subscriptions.push(this.sub$);
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  /**
   * - getRawValue from FormBroup even if disabled
   * - Update/patch part of the order
   * @param apiName
   */
  save(apiName: string): void {
    const resp = this.form.getRawValue();
    this.store.dispatch(new PatchOrdersAction({ order: resp, api: apiName }));
    this.resetDhlMsg.emit();
   // this.storeRoot.dispatch(new LoadProductsCompleteListAction());
  }

  undo(formPath: string[]): void {
    if (formPath && formPath[0] === 'concepts') {
      this.loadConcept();
    } else {
      this.resetDhlMsg.emit();
      if (formPath[1] !== 'commentsForm') {
        this.patchValueNotCommentForm(formPath);
      } else {
        this.form.get(formPath.concat('comments')).reset();
      }
    //  this.storeRoot.dispatch(new LoadProductsCompleteListAction());
    }
  }

  patchValueNotCommentForm(formPath: string[]): void {
    if (formPath[0] === 'addresses') { // update shipping address si undo
      this.patchValueAddress(formPath);
    } else {
      this.form.get(formPath).patchValue(_.get(this.orderForm, formPath)); // normal update undo form
      this.form.get(formPath).markAsPristine();
    }
  }

  /**
   * If (is an shipping address in Object Order):
   *  - patch value to the form shipping address from Object Order
   *  - set checkbox unchecked
   * else
   *  - reset shipping array
   *  - set checkbox checked
   */
  patchValueAddress(formPath: string[]): void {
    let arr = null;
    let res = null;
    if (formPath[1] === '0') {
      res = this.orderForm.addresses[0];
      arr = this.getArrayAddress(0);
      arr.patchValue(res);
      arr.get(['countryForm', 'name']).patchValue(arr.get('country').value);
    } else if (formPath[1] === '1') {
      arr = this.getArrayAddress(1);
      if (this.orderForm.addresses[1]) {
        res = this.orderForm.addresses[1];
        arr.patchValue(res);
        arr.get('checkBox').patchValue(false);
        arr.get(['countryForm', 'name']).patchValue(arr.get('country').value);
      } else {
        this.resetOrDisableFormDataFromList('reset', arr, ['line1', 'line2', 'line3', 'zip', 'city', 'state', 'countryForm']);
        arr.get('checkBox').patchValue(true);
      }
      arr.markAsPristine();
    }

  }

  getInvalidControls(form: FormGroup): string[] {
    if (isDevMode()) {
      return this.findInvalidControlsService.find(form);
    }
  }

  getArrayAddress(index: number): FormGroup {
    const res = this.form.get('addresses') as FormArray;
    return res.controls[index] as FormGroup;
  }

  resetOrDisableFormDataFromList(action: string, form: FormGroup, path: string[]): void {
    path.forEach(field => {
      const control = form.get(field);
      if (action === 'reset') {
        control.reset();
      } else if (action === 'disable') {
        control.disable()
      }
    });
  }

  removePlayer(): void {
      const initialState = {
        title: 'CONFIRMATION',
        message: 'Are you sure you want to remove this player ? ',
        deleteBtn: true,
      };
      this.bsModalRef = this.modalService.show(ModalComponent, {initialState});
      this.sub$ = combineLatest(this.modalService.onHide).subscribe(() => {
        if (this.bsModalRef.content.isConfirmed) {
          this.store.dispatch(new RemoveOrderPlayerAction(this.order.uuid));
        }

      });
      this.subscriptions.push(this.sub$);
  }

}
